import { useStore } from '../../hooks/useStore';

import { isRightSidebarOpen, RIGHT_SIDEBAR_WIDTH_CSS } from './isRightSidebarOpen';

/**
 * The right sidebar is overlaid on the stage (it doesn't resize it), so the preview needs to
 * reserve the sidebar's width to stay centered in the visible area while the panel is open.
 */
export const useRightSidebarInset = (): string => {
  const isOpen = useStore(isRightSidebarOpen);
  return isOpen ? RIGHT_SIDEBAR_WIDTH_CSS : '0px';
};
